import React, {Component} from 'react'
import Field from '../../common/Field'
import Validator from '../../common/Validator'
import api from '../../../source/api'
import i18 from '../../../i18'

export default class BillingData extends Component {

    constructor(props) {
        super()
        this.state = {
            billing: props.billing
        }
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            billing: nextProps.billing
        })
    }

    render() {
        return (
            <section id='billing-data margin-top-50'>
                <div className='row'>
                    <div className='col-md-6 offset-md-3'>
                        <table className='table table-striped table-bordered'>
                            <tbody>
                            <tr>
                                <td>Cégnév</td>
                                <td>{this.state.billing.company}</td>
                            </tr>
                            <tr>
                                <td>Adószám</td>
                                <td>{this.state.billing.tax_number}</td>
                            </tr>
                            <tr>
                                <td>Ország</td>
                                <td>{this.state.billing.country}</td>
                            </tr>
                            <tr>
                                <td>Irányítószám</td>
                                <td>{this.state.billing.postal_code}</td>
                            </tr>
                            <tr>
                                <td>Város</td>
                                <td>{this.state.billing.city}</td>
                            </tr>
                            <tr>
                                <td>Cím</td>
                                <td>{this.state.billing.address}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>


            </section>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/profile/billingdata/billingdata.js